import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=044779ee&scoped=true&"
import script from "./Test.js?vue&type=script&lang=js&"
export * from "./Test.js?vue&type=script&lang=js&"
import style0 from "./Test.scss?vue&type=style&index=0&id=044779ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044779ee",
  null
  
)

export default component.exports